import React, { useEffect } from 'react';
import Layout from '@features/workspace/components/layouts/v1/layout';
import { Card, CardContent, Typography } from '@mui/material';

const CreditPage: React.FC<any> = () => {
  useEffect(() => {
    document.title = 'Lula Support - Lula Credit';
  }, []) //eslint-disable-line

  return (
    <>
      <Layout>
        <Card>
          <CardContent>
            <Typography variant="h6">Credit</Typography>
            <br />
            Coming soon...
          </CardContent>
        </Card>
      </Layout>
    </>
  );
};

export default CreditPage;
